// extracted by mini-css-extract-plugin
export default {"btnpwd":"_5129f45230"};